<template>
    <div class="form-group" v-bind:class="[{ 'has-messaging': uiStates.message }, 'has-'+uiStates.messageClass+'-message']">
        <div class="input-group">
            <div v-if="typeof field.prepend !== 'undefined' && field.prepend.enabled == true" class="input-group-prepend">
                <span class="input-group-text">
                    <span v-html="field.prepend.value"></span>
                </span>
            </div>
            <div v-if="!uiStates.isEditable" class="input-group">
                <div v-html="field.maskedValue" class="input-masked"></div>
                <div class="input-group-append">
                    <button class="btn btn-outline-primary" @click.prevent="enterEditMode(field)">Clear</button>
                </div>
            </div>
            <input v-else v-model="field.value" :disabled="field.disabled" type="text" :name="field.name" :required="field.required ? true : false" class="form-control">
        </div>
        <ul v-if="uiStates.message" class="message-listing">
            <li>{{uiStates.message}}</li>
        </ul>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import select2 from 'select2';

    Vue.use(VueEvents)

    export default {
        name: 'form-gated-input-text',
        props: ['FieldData', 'masterValue', 'activeLanguage'],
        components:{
        },
        data() {
            return {
                uiStates: {
                    message:"",
                    messageClass:"",
                    isEditable: false,
                },
                field: this.FieldData,
            }
        },
        mounted() {
            this.$emit('input', this.field.value);
            if (this.field.value == '') {
                this.uiStates.isEditable = true;
            }
        },
        created() {

        },
        watch: {

        },
        methods: {
            enterEditMode(field) {
                this.uiStates.isEditable = true;
                field.value = null;
            },
        }
    };
</script>

<style scoped lang="scss">
    .required-field{
        font-size: 16px;
        color: #AB5755;
        position: absolute;
        top: -4px;
    }
    label{
        position: relative;
    }
    .input-group{
        position: relative;
        .input-group-append{
            position: absolute;
            top:0;
            right:0;
        }
    }
    .input-masked{
        height:38px;
        width:100%;
        border-radius: 2px;
        border: solid 1px #dedede;
        font-size: 12px;
        color: #333;
        padding: 10px 15px;
        background:#eeeeee;
    }
</style>